import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom"; // ✅ Importamos useNavigate y Link
import "../styles/tubo_cerquero.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import ptr from "../img/ptr_draw.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
const TuboRedondo = () => {
  return (
    <section>
      <div className="servicios-container" style={{ textAlign: "center" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}
        >
          PTR y Perfiles Rectángulares
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px', display: 'flex', alignItems: 'center' }}>
        {/* Descripción del producto */}
        <div className="col-md-4 d-flex justify-content-center align-items-center" style={{ height: '450px', textAlign: 'justify' }}>
          <br /><br />
          <p style={{ marginLeft: '10px', textAlign: 'justify' }}>
            El PTR (Perfil Tubular Rectangular) es un material de construcción
            metálico en forma de tubo rectangular hueco, fabricado con acero. Se utiliza principalmente en
            estructuras ligeras que no requieren soportar grandes cargas, como marcos y protecciones para
            ventanas y puertas, barandales, rejas y otros elementos estructurales en herrería y carpintería
            metálica. Su diseño proporciona resistencia y estabilidad con un peso reducido, lo que lo hace ideal
            para aplicaciones en la construcción y la industria.
            <br /><br />
            <img src={ptr} alt="PTR" style={{ maxWidth: '350px', marginLeft: '30px' }} />
          </p>
        </div>

        {/* Tabla del producto */}
        <div className="col-md-8">
          {/* Contenedor con scroll para las tres tablas */}
          <div style={{ maxHeight: '70vh', overflowY: 'auto', maxWidth: '100%', margin: '0 auto' }}>
            <table class="table table-striped" style={{textAlign:'center'}}>
              <thead>
                <th colspan="8" className="text-center bg-orange text-white"
                  style={{fontSize: "1.5rem", padding: "10px", background:'#f58634'}}>
                  PTR y Perfiles Rectángulares
                </th>

                <tr>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Descripción</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Dim. Pulg</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Calibre (nominal)</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Espesor (pulgada)</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Inventario</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Longitud (metros)</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Piezas x Atado</th>
                  <th style={{background: "#ffe4b2", color: "#000"}}>Kilogramo x Metro</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{background: "#fff"}}>
                  <td rowspan="2">R-100</td>
                  <td rowspan="2">1.00 x .050</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6</td>
                  <td>120</td>
                  <td>0.52</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>120</td>
                  <td>0.68</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="2">R-125</td>
                  <td rowspan="2">1.25 x 0.75"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>99</td>
                  <td>0.7</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>99</td>
                  <td>0.92</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>R-151</td>
                  <td>1.50 x 1.00"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>84</td>
                  <td>1.16</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td style={{background: "#f0f0f0f7"}}>R-155</td>
                  <td style={{background: "#f0f0f0f7"}}>1.50 x 0.50"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR</td>
                  <td>6.03</td>
                  <td>98</td>
                  <td>0.2</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="2">R-175</td>
                  <td rowspan="2">1.75 x 0.75"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>84</td>
                  <td>0.88</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>84</td>
                  <td>1.16</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="4">R-200</td>
                  <td rowspan="4">2.00 x 1.00"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>50</td>
                  <td>1.06</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>50</td>
                  <td>1.4</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6</td>
                  <td>50</td>
                  <td>1.74</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GV</td>
                  <td>6</td>
                  <td>50</td>
                  <td>2.15</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="2">R-225</td>
                  <td rowspan="2">2.25 x 0.75"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>55</td>
                  <td>1.06</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>55</td>
                  <td>1.4</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="2">R-249</td>
                  <td rowspan="2"> 2.50 x 1.25"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>54</td>
                  <td>1.34</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR</td>
                  <td>6</td>
                  <td>54</td>
                  <td>1.77</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>R-250</td>
                  <td>2.50 x 1.50"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>48</td>
                  <td>2.91</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td style={{background: "#f0f0f0f7"}} rowspan="4">R-300</td>
                  <td style={{background: "#f0f0f0f7"}} rowspan="4">3.00 x 1.50"</td>
                  <td>22</td>
                  <td>0.0299</td>
                  <td>GV</td>
                  <td>6</td>
                  <td>49</td>
                  <td>1.34</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>20</td>
                  <td>0.359</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>49</td>
                  <td>1.61</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>49</td>
                  <td>2.13</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>49</td>
                  <td>3.29</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td style={{background: "#f0f0f0f7"}} rowspan="4">R-302</td>
                  <td style={{background: "#f0f0f0f7"}} rowspan="4">3.00 x 2.00"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>35</td>
                  <td>3.67</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>28</td>
                  <td>5.57</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>10</td>
                  <td>0.1345</td>
                  <td>N</td>
                  <td>6</td>
                  <td>28</td>
                  <td>6.2</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>3/16</td>
                  <td>0.188</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>28</td>
                  <td>8.34</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td style={{background: "#f0f0f0f7"}} rowspan="3">R-400</td>
                  <td style={{background: "#f0f0f0f7"}} rowspan="3">4.00 x 1.50"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>35</td>
                  <td>1.97</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>35</td>
                  <td>2.61</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>35</td>
                  <td>4.04</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="4">R-402</td>
                  <td rowspan="4">4.00 x 2.00"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>35</td>
                  <td>4.42</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>20</td>
                  <td>6.78</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>9</td>
                  <td>0.1495</td>
                  <td>N</td>
                  <td>6</td>
                  <td>20</td>
                  <td>8.33</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>3/16</td>
                  <td>0.188</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>20</td>
                  <td>10.24</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="5">R-403</td>
                  <td rowspan="5">4.00 x 3.00"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>20</td>
                  <td>5.18</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>15</td>
                  <td>7.99</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>9</td>
                  <td>0.1495</td>
                  <td>N</td>
                  <td>6</td>
                  <td>15</td>
                  <td>9.85</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>3/16</td>
                  <td>0.188</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>15</td>
                  <td>12.14</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td>1/4</td>
                  <td>0.25</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>15</td>
                  <td>15.63</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td style={{background: "#f0f0f0f7"}}>R-602</td>
                  <td style={{background: "#f0f0f0f7"}}>6.00 x 2.00"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>24</td>
                  <td>5.93</td>
                </tr>
                <tr style={{background: "#fff"}}>
                  <td rowspan="2">R-604</td>
                  <td rowspan="2">6.00 x 4.00"</td>
                  <td>11</td>
                  <td>0.01196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>12</td>
                  <td>11.63</td>
                </tr>
                <tr style={{background: "#ffe4b2"}}>
                  <td>1/4</td>
                  <td>0.25</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>12</td>
                  <td>23.22</td>
                </tr>

              </tbody>
            </table>

            <ul>
              <p>Productos especiales sujetos a mínimos de fabricación. </p>
              <p>Disponibles en RF con acabado Pintado y Galvanizado Pintado Verde en calibres 18 y 20.</p>
              <p>Norma de fabricación ASTM A500 O ASTM A513.</p>
              <p>Para factibilidad en diferentes calibres, longitudes y acabados pregunte a su asesor de
                ventas.</p>
              <p>Tubería ASTM A500 Grado B en calibres 11 y más gruesos.</p>
              <ul>
                <li>N-Natural.</li>
                <li>PR-Pintado Rojo</li>
                <li>GV-Galvanizado Verde</li>
                <li>GN-Galvanizado</li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </section >
  );
}

const Servicios = () => {
  return (
    <section className="nservicios text-center my-5">
      <h3>Nuestros Servicios</h3>
      <div className="servicios-container">
        <Link to='/servicio#corte_laser' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Corte Láser</p>
            <img src={require("../img/laser.png")} alt="Corte Láser" />
          </div>
        </Link>
        <Link to='/servicio#corte_tubo' style={{ textDecoration: 'none' }} >
          <div className="servicio">
            <p>Corte de Tubo</p>
            <img src={require("../img/corte_recto.png")} alt="Corte Recto" />
          </div>
        </Link>
        <Link to='/servicio#doblez' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Doblez de Lámina</p>
            <img src={require("../img/dobladora-lamina.png")} alt="Doblez de Lámina" />
          </div>
        </Link>
        <Link to='/servicio#doblez-tubo' style={{textDecoration:'none'}}>
          <div className="servicio">
            <p style={{ fontSize: "13px" }}>Doblez de Tubo</p>
              <img src={require("../img/dobladora-tubo.JPG")} alt="Doblez de Tubo" />
          </div>
        </Link>

      </div>
    </section>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Ptr = () => {
  return (
    <div>
      <NavBar />
      <TuboRedondo />
      <Servicios />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Ptr;
